<template>
  <div class="backups">
    <div class="backups__hint">
      Бэкап создаётся ежедневно в 03:30 МСК, хранятся последние 3. Архивы защищены паролем
      (BACKUP_ZIP_PASSWORD на сервере). В архив файлов попадают только файлы, загруженные после переноса
      хранилища.
    </div>
    <div class="backups__titles">
      <div class="backups__titles_date">Дата</div>
      <div class="backups__titles_file">База данных</div>
      <div class="backups__titles_file">Файлы (MinIO)</div>
    </div>
    <div class="backups__list">
      <div class="backups__empty" v-if="!loader && !sets.length">Бэкапов пока нет</div>
      <div class="backups__item" v-for="set in sets" :key="set.stamp">
        <div class="backups__item_date">{{ set.date }}</div>
        <div class="backups__item_file" v-for="kind in ['db', 'minio']" :key="kind">
          <template v-if="set[kind]">
            <div class="backups__item_download pointer" @click="download(set[kind].name)">Скачать</div>
            {{ formatSize(set[kind].size) }}
          </template>
          <template v-else>нет файла</template>
        </div>
      </div>
    </div>
  </div>
  <Loader v-if="loader" />
</template>
<script>
import { ref, computed, onMounted } from "vue";
import { useBackups } from "@/composition/useBackups.js";
import Loader from "@/components/Loader.vue";
export default {
  components: {
    Loader,
  },
  setup() {
    const { backups, getBackups, downloadBackup } = useBackups();
    const loader = ref(false);

    onMounted(() => {
      loader.value = true;
      getBackups().finally(() => {
        loader.value = false;
      });
    });

    const sets = computed(() => {
      const byStamp = {};
      backups.value.forEach((b) => {
        const set = byStamp[b.stamp] || (byStamp[b.stamp] = { stamp: b.stamp });
        set[b.kind] = b;
        set.date = set.date || new Date(b.created).toLocaleString("ru-RU");
      });
      return Object.values(byStamp).sort((a, b) => (a.stamp < b.stamp ? 1 : -1));
    });

    const formatSize = (bytes) => {
      const units = ["Б", "КБ", "МБ", "ГБ"];
      let i = 0;
      while (bytes >= 1024 && i < units.length - 1) {
        bytes /= 1024;
        i++;
      }
      return `${bytes.toFixed(i ? 1 : 0)} ${units[i]}`;
    };

    const download = (name) => {
      downloadBackup(name).catch(() => alert("Не удалось получить ссылку на бэкап"));
    };

    return {
      sets,
      loader,
      formatSize,
      download,
    };
  },
};
</script>

<style lang="scss" src="@/styles/profile/backups/backups.scss"></style>
